import { Button, Input, Modal } from "antd";
import React, { useState } from "react";
import styles from "./OwnersContainer.module.scss";
import phoneIcon from "../../Assets/my BIds/Frame.svg";
import Paginations from "Components/UI/Pagination/Pagination";
import threeDots from "../../Assets/blackDots.svg"

const data = [
  {
    id: "3444",
    companyName: "W004, 3000 lbs",
    name: "Alisher",
    address: "1430 willamette st# 460",
    phone: "+1231231230",
    email: "john@wiserinc.us",
  },
  {
    id: "3444",
    companyName: "W004, 3000 lbs",
    name: "Alisher",
    address: "1430 willamette st# 460",
    phone: "+1231231230",
    email: "john@wiserinc.us",
  },
  {
    id: "3444",
    companyName: "W004, 3000 lbs",
    name: "Alisher",
    address: "1430 willamette st# 460",
    phone: "+1231231230",
    email: "john@wiserinc.us",
  },
  {
    id: "3444",
    companyName: "W004, 3000 lbs",
    name: "Alisher",
    address: "1430 willamette st# 460",
    phone: "+1231231230",
    email: "john@wiserinc.us",
  },
  {
    id: "45454",
    companyName: "W004, 3000 lbs",
    name: "Alisher",
    address: "1430 willamette st# 460",
    phone: "+1231231230",
    email: "john@wiserinc.us",
  },
];

export const OwnersContainer = () => {
  const [isAddOwnerOpen, setIsAddOwnerOpen] = useState(false);

  const hanldeAddOwner = () => setIsAddOwnerOpen(true);

  return (
    <div className={styles.owners}>
      <div className={styles.owners__header}>
        <h1>Owners</h1>

        <Button className={styles.owners__header__btn} onClick={hanldeAddOwner}>
          + Add owner
        </Button>
      </div>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>ID</th>
            <th>COMPANY NAME</th>
            <th>NAME </th>
            <th>ADDRESS</th>
            <th>PHONE NUMBER</th>
            <th>EMAIL </th>
            <th>ACTION </th>
          </tr>
        </thead>

        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td>
                {item.id}
              </td>
              <td>{item.companyName}</td>
              <td>{item.name}</td>
              <td>{item.address}</td>
              <td>{item.phone}</td>
              <td>{item.email}</td>
              <td>
                <img className={styles.phoneIcon} src={phoneIcon} alt="phone-icon" />
                <img src={threeDots} alt="phone-icon" />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Paginations link="owners" />

      {/* Add Driver Modal */}
      <Modal
        onCancel={() => setIsAddOwnerOpen(false)}
        title={<h2 className={styles.addOwnerTitle}>Create Owner</h2>}
        visible={isAddOwnerOpen}
        width={500}
        footer={null}
        className={styles.addOwnerModal}
      >
        <div className={styles.addVehicleModal}>
          <form className={styles.form}>
           
            <div className={styles.mainInfo}>
            <div>
                <label htmlFor="">Owner company name</label>
                <Input  />
              </div>
              <div>
                <label htmlFor="">First Name</label>
                <Input />
              </div>
              <div>
                <label htmlFor="">Last Name</label>
                <Input />
              </div>
              
              <div>
                <label htmlFor="">Email</label>
                <Input type="email" />
              </div>
              <div>
                <label htmlFor="">Phone Number</label>
                <Input type="phone"/>
              </div>
              <div>
                <label htmlFor="">Address</label>
                <Input />
              </div>
              
             
            </div>

            <Button className={styles.saveBtn}>Create</Button>
          </form>
        </div>
      </Modal>
    </div>
  );
};
